module.exports = __webpack_public_path__ + "static/media/myemoji.1135e6d5.png";